module.exports = __webpack_public_path__ + "static/media/Ваганова К., Шелудько А..2c6a9577.pdf";